module.exports = __webpack_public_path__ + "img/assets.5be72bf5.svg";